var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnowledge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.875 14.7501C42.75 11.5001 46.75 10.3751 50 12.1251C53.25 13.8751 54.375 18.0001 52.625 21.2501M50 53.8751C53.25 52.0001 54.375 48.0001 52.625 44.7501M56.625 25.0001C61.125 25.0001 64.75 28.6251 64.75 33.1251C64.75 37.6251 61.125 41.2501 56.625 41.2501M30 53.8751C26.75 52.0001 25.625 48.0001 27.375 44.7501M39.125 14.7501C37.25 11.5001 33.25 10.3751 30 12.1251C26.75 14.0001 25.625 18.0001 27.375 21.2501M23.375 41.1251C18.875 41.1251 15.25 37.5001 15.25 33.0001C15.25 28.5001 18.875 24.8751 23.375 24.8751",
    stroke: "url(#paint0_linear_631_2671)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 54.75C30.5 54.75 28.125 53.125 27.125 50.75H26.5C22.75 50.75 19.75 47.75 19.75 44C19.75 42.75 20.125 41.625 20.625 40.625C17.375 39.5 15.125 36.5 15.125 33C15.125 29.5 17.375 26.375 20.625 25.375C20 24.375 19.75 23.25 19.75 22C19.75 18.25 22.75 15.25 26.5 15.25H27.125C28.125 12.875 30.5 11.25 33.25 11.25C37 11.25 39.875 14.25 40 18C40 14.25 43 11.25 46.75 11.25C49.5 11.25 51.875 12.875 52.875 15.25H53.5C57.25 15.25 60.25 18.25 60.25 22C60.25 23.25 59.875 24.375 59.375 25.375C62.625 26.5 64.875 29.5 64.875 33C64.875 36.5 62.625 39.625 59.375 40.625C60 41.625 60.25 42.75 60.25 44C60.25 47.75 57.25 50.75 53.5 50.75H52.875C51.875 53.125 49.5 54.75 46.75 54.75M33.125 68.125H46.75C48.375 68.125 49.625 69.375 49.625 71C49.625 72.625 48.375 73.875 46.75 73.875H33.125C31.5 73.875 30.25 72.625 30.25 71M33.125 68.125H46.875M33.125 68.125C31.5 68.125 30.25 66.875 30.25 65.25C30.25 63.625 31.5 62.375 33.125 62.375H46.75C48.375 62.375 49.625 63.625 49.625 65.25M43.625 77.625C42.625 78.375 41.375 78.75 40 78.75C38.625 78.75 37.5 78.375 36.375 77.625",
    stroke: "url(#paint1_linear_631_2671)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.625 57.25V33C37.625 31.25 36.25 29.875 34.5 29.875C32.75 29.875 31.375 31.25 31.375 33C31.375 34.75 32.75 36.125 34.5 36.125H45.625C47.375 36.125 48.75 34.75 48.75 33C48.75 31.25 47.375 29.875 45.625 29.875C43.875 29.875 42.5 31.25 42.5 33V57.25M40 18V23.5M69 33H71.75M8.25 33H11M40 1.25V4.125",
    stroke: "url(#paint2_linear_631_2671)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 53.5L62.5 55.5M17.5 10.625L19.5 12.625M19.5 53.5L17.5 55.5M62.5 10.625L60.5 12.625",
    stroke: "url(#paint3_linear_631_2671)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_631_2671",
    x1: 15.2502,
    y1: 32.5897,
    x2: 64.75,
    y2: 32.5897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_631_2671",
    x1: 15.1252,
    y1: 45.0005,
    x2: 64.875,
    y2: 45.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_631_2671",
    x1: 8.25032,
    y1: 29.2504,
    x2: 71.75,
    y2: 29.2504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_631_2671",
    x1: 17.5002,
    y1: 33.0628,
    x2: 62.5,
    y2: 33.0628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledge);
export default __webpack_public_path__ + "static/media/Knowledge.f2d179f9b5d2d0f1a88978701c8717a8.svg";
export { ForwardRef as ReactComponent };